import './App.css';
import Header from './components/header';
import Hero from './components/hero';
import Categories from "./components/Categories";
import Ingredients from "./components/Ingredients"
import StepsSection from "./components/StepsSection";
import AppFeatures from './components/AppFeatures';
import HowItWorks from './components/HowItWorks';
import Faq from './components/Faq';
import AppShowcase from './components/AppShowcase';
import Footer from "./components/Footer";


function App() {
  return (
    <div className="App font-['Cairo']">
      <Header/>
      <main>
        <Hero/>
        <Categories />
        <Ingredients/>
        <StepsSection />
        <AppFeatures />
        <HowItWorks />
        <Faq />
        <AppShowcase />
      </main>
      <Footer />
    </div>
  );
}

export default App;
